import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Without this, a throw anywhere below unmounts the whole tree and leaves a blank
 * white page — no message, no way back, and on the kiosk a camera still running. A
 * screen that says what happened is the minimum a phone on a shop floor deserves.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error?: Error }> {
  state: { error?: Error } = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unhandled error', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto max-w-md p-6 text-center">
        <p className="text-base font-semibold">Something broke on this screen.</p>
        <p className="mt-2 break-words text-sm text-ink-600">{this.state.error.message}</p>
        <button
          type="button"
          className="btn-primary mt-4 w-full py-3 text-base"
          onClick={() => window.location.reload()}
        >
          Reload
        </button>
      </div>
    );
  }
}
